import React from 'react'
import PropTypes from 'prop-types'

import styles from './callToBookHeader.module.scss'

const CallToBookHeader = ({ className = '', ...rest }) => {
  return (
    <section className={`${styles.callToBookHeader} ${className}`} {...rest}>
      <div className={styles.callToBook__imgBlock}></div>
    </section>
  )
}

CallToBookHeader.propTypes = {
  className: PropTypes.string,
}

export { CallToBookHeader }
